import HomePage from './layout/home';
import CategoryPage from './layout/book/category';
import ReadPage from './layout/book/read';
import DetailPage from './layout/book/detail';
import BookrackPage from './layout/user/bookrack';
import AboutPage from './layout/about';
// import BenefitPage from './layout/benefit';
// import RankPage from './layout/book/rank';
// import Benefit2024Page from './layout/longBenefit';
// import ShortBenefit from './layout/shortBenefit';
import AuthorBenefit from './layout/authorBenefit';


export default [
    {
        nav_name: '首页',
        path: '/',
        component: HomePage,
    },
    {
        nav_name: '分类',
        path: '/category',
        component: CategoryPage,
    },
    /* {
        path: '/rank',
        nav_name: '排行榜',
        component: RankPage,
    }, */
    /* {
        nav_name: '长篇福利',
        path: '/longBenefit',
        component: Benefit2024Page,
    }, */
    /* {
        nav_name: '短篇福利',
        path: '/shortBenefit',
        component: ShortBenefit,
    }, */
    {
        nav_name: '作者福利',
        path: '/authorBenefit',
        component: AuthorBenefit,
    },
    {
        nav_name: '创作后台',
        url: 'https://writer.cgwrite.cn',
    },
    {
        nav_name: '关于长歌',
        path: '/about',
        component: AboutPage,
    },
    /* {
        nav_name: '客户端',
        url: 'https://img.wandu.cn/fe/pc_download/download.html',
    }, */
    {
        path: '/book/detail/:novel_id',
        component: DetailPage,
    },
    {
        path: '/book/read/:novel_id',
        component: ReadPage,
    },
    {
        path: '/book/read/:novel_id/:order_num',
        component: ReadPage,
    },
    {
        path: '/user/bookrack',
        component: BookrackPage,
    }
];



// WEBPACK FOOTER //
// ./src/route.js